module.exports = __webpack_public_path__ + "img/language.a299fd78.svg";